// extracted by mini-css-extract-plugin
export default {"head":"style--head--1d88ef"};